import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { SkillsAdapter } from './dto/skills.adapter';
import { SkillsController } from './skills.controller';
import { Skills } from './skills.entity';
import { SkillsService } from './skills.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([Skills]),
  ],
  controllers: [SkillsController],
  providers: [SkillsService, SkillsAdapter, ApplicationExceptionHandler,LogsService],
  exports: [SkillsService]
})
export class SkillsModule {}
